import React from 'react';
import PropTypes from 'prop-types';
import { CONTENT_TITLE } from '../../../constants/texts';
import IssueContainer from './IssueContainer';
import { useContactStyles } from './styles';
import { Typography } from '@material-ui/core';

const Contact = ({ ...props }) => {
  const { mobile } = props;
  const classes = useContactStyles();
  return (
    <React.Fragment>
      <Typography className={classes.title}>{CONTENT_TITLE} </Typography>
      <IssueContainer mobile={mobile} />
    </React.Fragment>
  );
};

Contact.propTypes = {
  mobile: PropTypes.bool,
};

export default Contact;
